// extracted by mini-css-extract-plugin
export default {"root":"DataSourcesRoot_root__r+E2-","body":"DataSourcesRoot_body__DATfZ","grid":"DataSourcesRoot_grid__QOqzH","card":"DataSourcesRoot_card__+VzQU"};